import { Injectable, inject } from '@angular/core';

import { TrackingService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class BetstationLoginTrackingService {
    private readonly trackingService = inject(TrackingService);

    trackLoginPinShown() {
        this.triggerEvent('contentView', {
            'component.CategoryEvent': 'login process',
            'component.LabelEvent': 'login screen',
            'component.ActionEvent': 'load',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'pin number screen',
            'component.EventDetails': 'pin number screen',
        });
    }

    trackErrorMessageShown(message: string) {
        this.triggerEvent('contentView', {
            'component.CategoryEvent': 'login process',
            'component.LabelEvent': 'login screen',
            'component.ActionEvent': 'load',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'error message',
            'component.EventDetails': message,
        });
    }

    trackErrorMessageOk(message: string) {
        this.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'login process',
            'component.LabelEvent': 'login screen',
            'component.ActionEvent': 'click',
            'component.PositionEvent': message,
            'component.LocationEvent': 'error message',
            'component.EventDetails': 'ok',
        });
    }

    private triggerEvent(eventName: string, eventData: Record<string, any>) {
        const enrichedEventData = {
            ...eventData,
            'login.customTimeStamp': Date.now() * 1000,
        };

        this.trackingService.triggerEvent(eventName, enrichedEventData);
    }
}
